export const NATIVE_LOGIN_ROUTE = "native-login";
export const NATIVE_LOGIN_CALLBACK_PROTOCOL = "logbook:";

export interface NativeLoginRequest {
  state: string;
  redirect: string;
}

export function parseNativeLoginRequest(search: string, pageOrigin: string = window.location.origin): NativeLoginRequest | undefined {
  const params = new URLSearchParams(search);
  const state = params.get("state");
  const redirect = params.get("redirect");
  if (!state || !redirect) {
    return undefined;
  }

  try {
    const url = new URL(redirect);
    const browserCallback =
      url.origin === pageOrigin &&
      url.pathname === "/app/native-login/browser-callback" &&
      url.username === "" &&
      url.password === "" &&
      url.hash === "";
    if (url.protocol !== NATIVE_LOGIN_CALLBACK_PROTOCOL && !browserCallback) {
      return undefined;
    }
    return { state, redirect: url.toString() };
  } catch {
    return undefined;
  }
}

export function buildNativeLoginCallback(request: NativeLoginRequest, code: string): string {
  const callback = new URL(request.redirect);
  callback.searchParams.set("code", code);
  callback.searchParams.set("state", request.state);
  return callback.toString();
}

export function redirectToNativeLoginCallback(url: string): void {
  window.location.href = url;
}
